var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sectionClass},[_c('p',{class:_vm.fields.textColour.fields.colourSlug},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.fields.quote)}}),_vm._v(" –\n    "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.fields.author)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25c706cd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestimonialItem.vue
// module id = 344
// module chunks = 1